import  api, { globalErrorHandler } from "../Api"

export const GET_IMAGES = "GET_IMAGES";
export const GET_RAFTIMAGES = "GET_RAFTIMAGES";
export const RE_LOADING = "RE_LOADING";
export const GET_HOME_VIDEO = "GET_HOME_VIDEO";

export const GetImages = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/api/Common/GetImages`).then(res => 
      dispatch({
        type: GET_IMAGES,
        data: res.data
        })
    ).catch(globalErrorHandler);
  };
};

export const GetRAFTImages = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/api/Common/GetRAFTImages`).then(res => 
      dispatch({
        type: GET_RAFTIMAGES,
        data: res.data
        })
    ).catch(globalErrorHandler);
  };
};

export const GetHomeVideo = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/CTAs/GetHomeVideo`).then(res => 
      dispatch({
        type: GET_HOME_VIDEO,
        data: res.data
        })
    ).catch(globalErrorHandler);
  }
};